export {
  collectStylesFromMoneyPost,
  filterByType,
  generateTargeting,
  getVerticalSlugs,
  getVerticals,
  handleCanonicalRedirect,
  injectBlockInLayout,
  matchDevice,
  matchGeoTarget,
  moneyMetaInfo,
  selectCampaignTargets,
  selectPlacement,
  selectRandomPlacement,
  selectTarget,
  targetPlacements,
  testPlacementSelection,
} from './utils';
export type { MoneyTemplateProps, PageProps } from './entities';

export { getMoneyPost, MoneyPost } from './components/MoneyPost';
export type { MoneyPostProps } from './components/MoneyPost';

export { getMoneyPage, getVertical } from './components/getMoneyPage';
export { MoneyPage } from './components/MoneyPage';
export type { MoneyPageProps } from './components/MoneyPage';

export { getMoneySidebar, MoneySidebar } from './components/MoneySidebar';
export type { MoneySidebarProps } from './components/MoneySidebar';

export { MoneyBlocks } from './components/MoneyBlocks';
export { LazyMoneyBlocks } from './components/LazyMoneyBlocks';
export { MoneyBlock } from './components/MoneyBlock';
export { MoneyHeader } from './components/MoneyHeader';
export type { MoneyBlockProps } from './components/MoneyBlock';

export { MoneyPostLayout } from './components/MoneyPostLayout';
export { MoneyBlocksLayout } from './components/MoneyBlocksLayout';

export { MoneyPostBreadcrumbs } from './components/MoneyPostBreadcrumbs';
export { FloatingPopup } from './components/Campaign/FloatingPopup';
export { CampaignPopup } from './components/Campaign/CampaignPopup';

export { MoneyWidget } from './components/MoneyWidget';
export { MoneyPosts } from './components/MoneyPosts';

export { TickerBox } from './components/Blocks/QuotesBlock';
export { Popup } from './components/Popup';
export { AdvertorialPopup } from './components/Popup/AdvertorialPopup';

export {
  BestStocksTemplate,
  CampaignTemplate,
  EdgePortfolioTemplate,
  EntitiesTemplate,
  LearnTemplate,
  MoneyPageTemplate,
  MoneyPostTemplate,
  NewsTemplate,
  ReviewTemplate,
} from './components/Templates';
export type { LearnTemplateProps } from './components/Templates';

export { TickerBoxBlock } from './components/Blocks/TickerBoxBlock';

export { AffiliateContext, AffiliateProvider } from './context/AffiliateContext';

export {
  canShowMorty,
  canShowFigureRefi,
  canShowHSH,
  canShowNewAmericanFunding,
  textValue,
  numberValue,
  getPathFromURL,
} from './components/Mortgage/Helper';

export { ButtonCardGroup } from './components/Mortgage/ButtonCardGroup';
export { Error } from './components/Mortgage/Error';
export { FunnelProgress } from './components/Mortgage/FunnelProgress';
export { default as mortgageStyles } from './components/Mortgage/mortgage.module.scss';
export { Submit } from './components/Mortgage/Submit';
export { ZipCodeStep } from './components/Mortgage/Steps/ZipCodeStep';

export { ButtonStep } from './components/Mortgage/Steps/ButtonStep';
export { SliderStep } from './components/Mortgage/Steps/SliderStep';

export { Quicklinks } from './components/Quicklinks';
export type { QuickLinkItem } from './components/Quicklinks';

export { ReviewedByBenzinga } from './components/ReviewedByBenzinga';
export type { ReviewedByBenzingaProps } from './components/ReviewedByBenzinga';

export { MoneyLayoutHeader } from './components/MoneyLayoutHeader';
export type { MoneyLayoutHeaderProps } from './components/MoneyLayoutHeader';

export { NewsWithTabs } from './components/NewsWithTabs';
export { NewsCardItem } from './components/NewsWithTabs/NewsCardItem';
export type { NewsWithTabsProps, NewsWithTabsTabContent, ArticleTab } from './components/NewsWithTabs';

export { BasicInfoCards } from './components/BasicInfoCards';
export type { BasicInfoCardsProps } from './components/BasicInfoCards';

export { MoneyServicesList } from './components/MoneyServicesList';
export type { MoneyServicesListProps } from './components/MoneyServicesList';

export { NewsListWithPagination } from './components/NewsListWithPagination';
export type { NewsListWithPaginationProps } from './components/NewsListWithPagination';

export { EconomicsColumnsDef } from './components/Tables/ColumnDefs/EconomicsColumnsDef';
export { RatingsColumnsDef } from './components/Tables/ColumnDefs/RatingsColumnsDef';
export { EarningsColumnsDef } from './components/Tables/ColumnDefs/EarningsColumnsDef';

export type { TestimonialData } from './components/TestimonialCard';
export { TestimonialCard } from './components/TestimonialCard';
export { TestimonialSlider } from './components/TestimonialSlider';

export { FuturesTableCompact } from './components/Futures/FuturesTableCompact';

export { CommentBlock } from './components/Blocks/CommentBlock';
